import { render, staticRenderFns } from "./VerifyIbanModal.vue?vue&type=template&id=f70f4d2a&scoped=true"
import script from "./VerifyIbanModal.vue?vue&type=script&lang=js"
export * from "./VerifyIbanModal.vue?vue&type=script&lang=js"
import style0 from "./VerifyIbanModal.vue?vue&type=style&index=0&id=f70f4d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70f4d2a",
  null
  
)

export default component.exports